import React from 'react';
import PropTypes from 'prop-types';
import { SORT_MENU_PACHI, SORT_MENU_SLOT } from '../../../constants/K007/SortMenuInfo';

/**
 * SelectSortMenuModal
 */
class SelectSortMenuModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      displayItem: '',
      sortMenuInfoPachi: SORT_MENU_PACHI,
      sortMenuInfoSlot: SORT_MENU_SLOT,
      sortMenuInfoPachiKey: this.props.data.sortKey,
      sortMenuInfoSlotKey: this.props.data.sortKey
    };
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handlePachiLabelClick = this.handlePachiLabelClick.bind(this);
    this.handleSlotLabelClick = this.handleSlotLabelClick.bind(this);
  }

  /**
   * パチンコソート項目押下
   */
  handlePachiLabelClick(key) {
    // 直前のソート条件と同一の場合は画面更新しない
    if (key == this.props.data.sortKey) {
      $('#sort_menu_modal').hide();
      return;
    }
    this.setState({ sortMenuInfoPachiKey: key });
    const sortOrder = this.props.data.sortOrder;
    this.props.actions.clickSortSummary(key, sortOrder);
    $('#sort_menu_modal').hide();
  }

  /**
   * スロットソート項目押下
   */
  handleSlotLabelClick(key) {
    // 直前のソート条件と同一の場合は画面更新しない
    if (key == this.props.data.sortKey) {
      $('#sort_menu_modal').hide();
      return;
    }
    this.setState({ sortMenuInfoSlotKey: key });
    const sortOrder = this.props.data.sortOrder;
    this.props.actions.clickSortSummary(key, sortOrder);
    $('#sort_menu_modal').hide();
  }

  /**
   * ソート項目以外の領域を押下
   */
  handleCloseModal() {
    $('#sort_menu_modal').hide();
  }

  render() {
    let SortMenuInfoPSNode = this.state.sortMenuInfoSlot.map((slotInfo) => {
      let clsName = 'content_item_border_default';
      if (slotInfo.key === this.props.data.sortKey) {
        clsName += ' modal_display_item_panel_content_item_on_k007';
      } else {
        clsName += ' modal_display_item_panel_content_item_off_k007';
      }
      return (
        <div className={clsName} key={slotInfo.key} onClick={() => this.handleSlotLabelClick(slotInfo.key)}>
          <span>{slotInfo.name}</span>
        </div>
      );
    });
    if (this.props.data.rate <= 2) {
      SortMenuInfoPSNode = this.state.sortMenuInfoPachi.map((pachiInfo) => {
        let clsName = 'content_item_border_default';
        if (pachiInfo.key === this.props.data.sortKey) {
          clsName += ' modal_display_item_panel_content_item_on_k007';
        } else {
          clsName += ' modal_display_item_panel_content_item_off_k007';
        }
        return (
          <div className={clsName} key={pachiInfo.key} onClick={() => this.handlePachiLabelClick(pachiInfo.key)}>
            <span>{pachiInfo.name}</span>
          </div>
        );
      });
    }


    return (
      <div id="sort_menu_modal" className="modal_display_item_panel" onClick={e => this.handleCloseModal(e)}>

        <div className="modal_display_item_panel_bg">
          <div className="modal_display_item_panel_top">
            <div className="modal_display_item_panel_parent">
              <div className="modal_display_item_panel_header">
                <span>ソート条件</span>
              </div>
              <div className="modal_display_item_panel_content_title_k007">
                <span>項目</span>
              </div>
              <div className="modal_display_item_panel_content_k007 fb">
                <div className="modal_display_item_panel_content_inner_k007">
                  {SortMenuInfoPSNode}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SelectSortMenuModal.propTypes = {
  actions: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired,
};

export default SelectSortMenuModal;
